import { Shirt, Medal, Gift, Trophy, BadgeDollarSign, Phone, CalendarDays, Ticket } from "lucide-react";

const KIT = [
  { icon: Shirt, t: "Blusa do evento" },
  { icon: Medal, t: "Medalha para todos os participantes" },
  { icon: Gift, t: "Sorteio de brindes" },
];
const BRACKETS = ["14 a 29 anos", "30 a 39 anos", "40 a 49 anos", "50+ anos"];
const PRIZES = [
  { sport: "Corrida 5KM", rows: [["Homens até 39 anos", 1000, 500, 300], ["Homens 40+ anos", 1000, 500, 300], ["Mulheres até 39 anos", 1000, 500, 300], ["Mulheres 40+ anos", 1000, 500, 300]] },
  { sport: "Ciclismo 10KM", rows: [["Homens", 300, 200, 100], ["Mulheres", 300, 200, 100]] },
];
const money = (v) => `R$ ${v.toLocaleString("pt-BR")}`;

export const EventInfo = ({ event }) => {
  const openDate = event?.registration_open ? new Date(event.registration_open + "T00:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) : "25/09";
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-20 space-y-6" data-testid="event-info-section">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-2xl bg-brand text-ink font-display font-black uppercase text-2xl px-6 py-4 flex items-center gap-3"><Ticket className="w-8 h-8" /> Vagas Limitadas</div>
        <div className="rounded-2xl bg-brand text-ink font-display font-black uppercase text-2xl px-6 py-4 flex items-center gap-3"><Gift className="w-8 h-8" /> Sorteio de Brindes</div>
      </div>

      <div className="rounded-2xl border border-brand/40 bg-surface p-6" data-testid="kit-section">
        <h3 className="font-display text-2xl font-extrabold uppercase text-center mb-5">Kit do Participante</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {KIT.map((k) => (
            <div key={k.t} className="flex items-center gap-3 text-slate-200"><k.icon className="w-9 h-9 text-brand shrink-0" /><span>{k.t}</span></div>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2 rounded-2xl bg-brand/90 text-ink p-6" data-testid="trophies-section">
          <div className="flex items-center gap-3 mb-3"><Trophy className="w-9 h-9" /><h3 className="font-display text-2xl font-extrabold uppercase">Troféus por Categoria!</h3></div>
          <ul className="grid grid-cols-2 gap-x-6 gap-y-1 font-semibold">
            {BRACKETS.map((b) => <li key={b}>• {b}</li>)}
          </ul>
          <p className="text-xs mt-3 italic">Obs.: Os campeões nas Gerais não concorrem na categoria.</p>
        </div>
        <div className="rounded-2xl bg-brand/90 text-ink p-6 flex items-center gap-4">
          <BadgeDollarSign className="w-14 h-14 shrink-0" />
          <h3 className="font-display text-2xl font-extrabold uppercase leading-tight">Premiação em Dinheiro!</h3>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-white/10 bg-surface p-5 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-brand flex items-center justify-center"><Phone className="w-7 h-7 text-ink" /></div>
          <div><p className="text-slate-400 text-sm">Informações e Inscrições:</p><p className="font-display text-2xl font-black" data-testid="info-phone">{event?.contact_phone || "(97) 98432-1588"}</p></div>
        </div>
        <div className="rounded-2xl border border-white/10 bg-surface p-5 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-brand flex items-center justify-center"><CalendarDays className="w-7 h-7 text-ink" /></div>
          <div><p className="text-slate-400 text-sm">Abertura das Inscrições:</p><p className="font-display text-2xl font-black" data-testid="info-open-date">{openDate}</p>{event?.site_url && <p className="text-neon font-bold text-sm">{event.site_url}</p>}</div>
        </div>
      </div>

      <div className="rounded-2xl overflow-hidden border border-white/10" data-testid="prizes-table">
        <div className="bg-brand-hover text-center font-display text-2xl font-black uppercase py-3">Premiação <span className="text-neon">R$ 10 MIL</span></div>
        <table className="w-full text-sm">
          <tbody>
            {PRIZES.map((p) => (
              <FragmentRows key={p.sport} p={p} />
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

const FragmentRows = ({ p }) => (
  <>
    <tr className="bg-brand text-ink font-bold uppercase">
      <td className="px-4 py-2 bg-ink text-white font-display italic">{p.sport}</td>
      <td className="px-4 py-2 text-center">🥇 1º</td><td className="px-4 py-2 text-center">🥈 2º</td><td className="px-4 py-2 text-center">🥉 3º</td>
    </tr>
    {p.rows.map((r) => (
      <tr key={r[0]} className="odd:bg-surface even:bg-ink border-b border-white/5">
        <td className="px-4 py-2 uppercase text-slate-200">{r[0]}</td>
        {r.slice(1).map((v, i) => <td key={`${r[0]}-${i}`} className="px-4 py-2 text-center font-mono font-semibold">{money(v)}</td>)}
      </tr>
    ))}
  </>
);

export default EventInfo;
